var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.639753 0.938335L4.48505 4.80157C4.54703 4.86381 4.62391 4.91376 4.71043 4.94801C4.79695 4.98227 4.89105 5 4.98627 5C5.0815 5 5.17559 4.98227 5.26211 4.94801C5.34863 4.91376 5.42551 4.86381 5.4875 4.80157L9.33279 0.938336C9.69977 0.569586 9.39551 4.69277e-07 8.83156 4.25522e-07L1.13988 -1.71259e-07C0.575931 -2.15014e-07 0.271675 0.569585 0.639753 0.938335Z",
    fill: "#95A3CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDown);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEwIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjYzOTc1MyAwLjkzODMzNUw0LjQ4NTA1IDQuODAxNTdDNC41NDcwMyA0Ljg2MzgxIDQuNjIzOTEgNC45MTM3NiA0LjcxMDQzIDQuOTQ4MDFDNC43OTY5NSA0Ljk4MjI3IDQuODkxMDUgNSA0Ljk4NjI3IDVDNS4wODE1IDUgNS4xNzU1OSA0Ljk4MjI3IDUuMjYyMTEgNC45NDgwMUM1LjM0ODYzIDQuOTEzNzYgNS40MjU1MSA0Ljg2MzgxIDUuNDg3NSA0LjgwMTU3TDkuMzMyNzkgMC45MzgzMzZDOS42OTk3NyAwLjU2OTU4NiA5LjM5NTUxIDQuNjkyNzdlLTA3IDguODMxNTYgNC4yNTUyMmUtMDdMMS4xMzk4OCAtMS43MTI1OWUtMDdDMC41NzU5MzEgLTIuMTUwMTRlLTA3IDAuMjcxNjc1IDAuNTY5NTg1IDAuNjM5NzUzIDAuOTM4MzM1WiIgZmlsbD0iIzk1QTNDQyIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };